function e(f){return typeof Buffer<"u"&&Buffer.isBuffer(f)}export{e as isBuffer};
